<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Transfer To Cash Wallet</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Amount</label>
                        <input v-model="transfer.amount" type="number" @focus="$event.target.select()" class="form-control" />
                    </div>

                    <!--<div class="form-group col-md-12">
                        <label>Description</label>
                        <input v-model="transfer.description" class="form-control" />
                    </div>-->
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn btn-primary btn-round" v-on:click="SaveFund()" v-bind:disabled=" (transfer.amount > amount) || transfer.amount <= 0">Transferred</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        props: ['bonusAmount', 'props', 'show'],
        data: function () {
            return {
                transfer: {
                    id: '00000000-0000-0000-0000-000000000000',
                    amount: 0,
                    description: '',
                    props: '',

                },
                amount: 0,
                loading: false,
                bonusesAmount: {
                    directBonus: 0,
                    inDirectBonus: 0,
                    uniLevelBonus: 0,
                    roIBonus: 0,
                    socialMediaBonus: 0,
                    poolBonus: 0,
                },
            }
        },
        validations: {
            transfer: {
                amount: {
                    required: required
                }
            }
        },
        methods: {


            SaveFund: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Bonus/RoiBonusToCashWallet', this.transfer, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Transferred!',
                                text: 'Amount has been transferred successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.close();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },


            close: function () {
                this.$emit('close');
            }
        },

        created: function () {
            this.bonusesAmount = this.bonusAmount;
            this.transfer.props = this.props;
            if (this.props =='ROI') {
                this.amount = this.bonusAmount.roIBonus;
            }
            if (this.props == 'UniLevel') {
                this.amount = this.bonusAmount.uniLevelBonus;
            }
            if (this.props == 'Direct') {
                this.amount = this.bonusAmount.directBonus;
            }
            if (this.props == 'InDirect') {
                this.amount = this.bonusAmount.inDirectBonus;
            }
        },
        mounted: function () {

        },

    }
</script>